import Vue from 'vue'
import Vuex from 'vuex'
import { MutationTree, ActionTree, GetterTree } from 'vuex'
import { root } from '@/shared/store'

import { IDictionary } from '@/shared/models/interface/dictionary-model'

import CookieService from '@/shared/services/cookie-service'
import { impersonation } from './impersonation'
import { showAll } from './show-all'

export interface IWidgetState {
    readonly cookieKey: string
    settings: IDictionary<boolean | string>
}

export class WidgetState implements IWidgetState {
    readonly cookieKey: string = 'content-switch'
    settings: IDictionary<string | boolean> = {}
}

export const mutations: MutationTree<IWidgetState> = {
    /** content-switch {
     *      showAll: true/false
     *      audience: ''
     *      studyType: ''
     *      faculty: ''
     *      study: ''
     * } **/
    setSettings(state, settings: IDictionary<boolean | string> | null) {
        state.settings = settings ?? {}
    },

    setCookie(state) {
        CookieService.setCookie(state.cookieKey, JSON.stringify(state.settings))
    },

    updateSetting(state, [key, value]) {
        Vue.set(state.settings, key, value)
    },

    removeSetting(state, key) {
        Vue.delete(state.settings, key)
    }
}

export const actions: ActionTree<IWidgetState, IWidgetState> = {
    init(context) {
        context.commit('setSettings', context.getters.cookie)
    }
}

export const getters: GetterTree<IWidgetState, IWidgetState> = {
    cookie(state): IDictionary<boolean | string> | null {
        const cookie: string = CookieService.getCookie(state.cookieKey)
        return cookie ? JSON.parse(cookie) : null
    }
}

export default new Vuex.Store({
    state: new WidgetState,
    mutations: mutations,
    actions: actions,
    getters: getters,
    modules: {
        root,
        impersonation,
        showAll
    }
})
